// extracted by mini-css-extract-plugin
export var modal = "_lp-0";